import { Tooltip } from '@material-ui/core';
import React from 'react';
import { StudioControlStyles } from '../styles';



type Props = {
  title: string;
  children: React.ReactElement;
};

const StudioToolTip = ({ children, title }: Props) => {
  const classes = StudioControlStyles();

  return (
        <Tooltip
          title={title}
          classes={{
            tooltip: classes.tooltip,
            popper: classes.tooltipPopper,
          }}
        >
          {children}
        </Tooltip>
      )
};

export default StudioToolTip;
